import get from 'lodash/get';
import { createWithEqualityFn } from 'zustand/traditional';
import { collectOptions } from '../constants';

export const useCategories = createWithEqualityFn(() => ({
  checkpoint: {
    catalogArr: [],
    featuredCates: [],
  },
  lora: {
    catalogArr: [],
    featuredCates: [],
  },
}));

export const useModelsModal = createWithEqualityFn(() => ({
  baseTypes: undefined, // 合集不支持
  combinedTagCode: {}, //合集不支持
  keyword: '',
  collectState: {}, // 合集ID，用于记录在123级菜单中是否有点击对应的合集入口
  collectType: collectOptions[0].value,
  collectModels: {}, // 收藏数据 (翻页不生效)
  historyModels: [], // 最近使用数据(翻页不生效)
  hotModels: [], // 热门精选(翻页不生效)
  catesModels: {}, // 具体分类
  isInGlobalSearchState: false, // 全局搜索状态中
  isInGlobalSearching: false, // 全局异步数据搜索中 loading
  globalSearchDataCount: 0, // 全局搜索数据总数
  onlySeeStoreModel: false, // 是否在搜索模式下只看已搜藏
  workflowData: {},
  isInScrolling: false, // 页面是否存在滚动（用于UI控制）
  // 以下数据不做重置 页面不刷新需要反显交互 区分记录是因为比如lora和checkoutpint的id有可能重叠
  checkpointCurrentMenuId: null,
  loraCurrentMenuId: null,
  workflowCurrentMenuId: null,
}));

export const getModelsModalState = (keyPath) => {
  return get(useModelsModal.getState(), keyPath);
};

export const setModelsModalState = (newState) => {
  const state = useModelsModal.getState();
  useModelsModal.setState({ ...state, ...newState });
};

export const useModelsModalState = (keyPath) => {
  return useModelsModal((state) => get(state, keyPath));
};

export const getCurrentChoosedMenuState = (type) => {
  return get(useModelsModal.getState(), `${type}CurrentMenuId`);
};

export const useModels = createWithEqualityFn(() => ({
  keyword: {
    value: '',
  },
  recentFavoritedModels: [],
  checkpoint: {
    favorites: {
      filters: {
        keyword: '',
        baseType: '0',
        baseTypes: [],
        sortType: '1',
        page: 1,
        pageSize: 30,
      },
      data: {
        items: [],
        loading: false,
        hasMore: false,
        total: 0,
      },
    },
    history: {
      filters: {
        keyword: '',
        baseType: '0',
        baseTypes: [],
        page: 1,
        pageSize: 30,
      },
      data: { items: [], loading: false, hasMore: false, total: 0 },
    },
    all: {
      filters: {
        label2Code: undefined,
        keyword: '',
        category: '0',
        baseType: '',
        baseTypes: [],
        sortType: '0',
        page: 1,
        pageSize: 16,
      },
      data: { items: [], loading: false, hasMore: false, total: 0 },
    },
  },
  lora: {
    favorites: {
      filters: {
        keyword: '',
        category: '0',
        baseType: '0',
        baseTypes: [],
        sortType: '1',
        page: 1,
        pageSize: 30,
      },
      data: { items: [], loading: false, hasMore: false, total: 0 },
    },
    history: {
      filters: {
        keyword: '',
        baseType: '0',
        baseTypes: [],
        page: 1,
        pageSize: 30,
      },
      data: { items: [], loading: false, hasMore: false, total: 0 },
    },
    all: {
      filters: {
        keyword: '',
        category: '0',
        baseType: '3',
        baseTypes: [],
        sortType: '0',
        page: 1,
        pageSize: 16,
      },
      checkpointRelatedItems: [],
      promptRelatedItems: [],
      data: { items: [], loading: false, hasMore: false, total: 0 },
    },
    segments: {},
  },
}));

export const updatePartialState = (keyPath, partialState) => {
  const state = useModels.getState();
  const subState = get(state, keyPath);
  if (typeof partialState === 'function') {
    partialState = partialState(subState);
  }
  const nextState = { ...state };
  // 从底层往上层逐层更新每一层对象为新的引用，而不能直接修改原对象
  const keys = keyPath.split('.');
  keys.reduce((acc, key, index) => {
    if (index === keys.length - 1) {
      acc[key] = { ...subState, ...partialState };
    } else {
      acc[key] = { ...acc[key] };
    }
    return acc[key];
  }, nextState);
  useModels.setState(nextState);
};

export const getPartialState = (keyPath) => {
  return get(useModels.getState(), keyPath);
};

export const usePartialState = (keyPath) => {
  return useModels((state) => get(state, keyPath));
};

export const updateLoraSegState = (keyPath, partialState, featuredCate) => {
  const state = useModels.getState();
  const keyPathArr = keyPath.split('.');
  const data = {
    ...state,
    lora: {
      ...state.lora,
      segments: {
        ...state.lora.segments,
        [keyPathArr[0]]: {
          ...state.lora.segments[keyPathArr[0]],
          [keyPathArr[1]]: {
            featuredCate,
            partialState,
          },
        },
      },
    },
  };
  useModels.setState(data);
};
